export default __webpack_public_path__ + "static/logo_witteveen_bos@2x-1c1ca572c4ec8f92dff16fad562dc2ba.png";